import { useNavigate } from "react-router-dom";

const DashboardCard = ({ icon, title, path }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/${path}`);
  };

  return (
    <div onClick={handleClick} className="dashboard-icon-item text-center mb-3 mb-xl-0">
      <img src={icon} alt={title} className="dashboard-icon" />
      <div className="icon-title mt-1">{title}</div>
    </div>
  );
};

export default DashboardCard;

